import { Injectable, signal } from '@angular/core';
import { StageOverride } from '../../shared/helpers/video-list';

/**
 * The viewer's own choice of the staged (presenting) tile, made with the
 * tile toggle. Local only: nothing is sent to other participants. Kept at
 * root because the video grid is recreated when the main and pinned
 * components swap.
 */
@Injectable({
  providedIn: 'root',
})
export class VideoStageService {
  private readonly _override = signal<StageOverride | null>(null);
  readonly override = this._override.asReadonly();

  setOverride(override: StageOverride) {
    this._override.set(override);
  }

  clear() {
    this._override.set(null);
  }
}
